import styled from 'styled-components';

import colors from 'themes/Main';

const { gray03 } = colors;

export const Text = styled.h1`
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: ${gray03};
  line-height: 28px;
`;
